import { render, staticRenderFns } from "./TheRadarIcon.vue?vue&type=template&id=54abe033&scoped=true&"
import script from "./TheRadarIcon.vue?vue&type=script&lang=js&"
export * from "./TheRadarIcon.vue?vue&type=script&lang=js&"
import style0 from "./TheRadarIcon.vue?vue&type=style&index=0&id=54abe033&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54abe033",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheRadarBadge: require('/web/components/TheRadarBadge.vue').default,TheRadarMonthBadge: require('/web/components/TheRadarMonthBadge.vue').default,TheRadarIsiBadge: require('/web/components/TheRadarIsiBadge.vue').default,TheRadarTopFiftyBadge: require('/web/components/TheRadarTopFiftyBadge.vue').default})
